import { SliderProps, BaseSliderProps, ThresholdSliderProps } from './types';
import { BaseSlider } from './BaseSlider';
import { ThresholdSlider } from './ThresholdSlider';

export const Slider = ({ isThresholdSlider, ...sliderProps }: SliderProps) => {
  return (
    <>{isThresholdSlider ? <ThresholdSlider {...(sliderProps as ThresholdSliderProps)} /> : <BaseSlider {...(sliderProps as BaseSliderProps)} />}</>
  );
};
